import { Switch } from "antd";
import React, { useState } from "react";

interface ViewField {
  label: string;
  key: string;
  order: number;
}

interface Props {
  viewFields: Array<ViewField>;
  onViewFieldsChange: (finalViewFields: Array<ViewField>) => void;
  allUserFields: { [key: string]: ViewField };
}

const ColumnsSwitch = ({
  viewFields,
  onViewFieldsChange,
  allUserFields,
}: Props) => {
  const viewFieldsKey = viewFields.map((field) => field.key);
  const [viewFieldsKeyMap, setViewFieldKeyMap] = useState(
    Object.keys(allUserFields).reduce(
      (acc, fieldKey) => ({
        ...acc,
        [fieldKey]: viewFieldsKey.includes(fieldKey),
      }),
      {}
    )
  );

  const onChange = (fieldKey) => (checked) => {
    const finalViewFieldsKeyMap = { ...viewFieldsKeyMap, [fieldKey]: checked };
    setViewFieldKeyMap(finalViewFieldsKeyMap);

    const finalViewFields = Object.keys(finalViewFieldsKeyMap)
      .filter((fieldKey) => finalViewFieldsKeyMap[fieldKey])
      .map((key) => allUserFields[key])
      .sort((a, b) => (a.order > b.order ? 1 : -1));

    onViewFieldsChange(finalViewFields);
  };

  return (
    <div className="flex flex-col gap-4">
      {Object.values(allUserFields)
        .sort((a, b) => (a.order > b.order ? 1 : -1))
        .map((field) => (
          <div key={field.key} className="flex justify-between items-center">
            <div className="flex items-center gap-2 text-sm text-gray-700">
              {field.label}
            </div>
            <Switch
              checked={viewFieldsKeyMap[field.key]}
              onChange={onChange(field.key)}
              size="small"
            />
          </div>
        ))}
    </div>
  );
};

export default ColumnsSwitch;
